// Author Lidongxu
// Date 2025-07-01 13:41:51

import * as model from "@/model/em/epc/EmEpcTagMaterialModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmEpcTagMaterial(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_EPC_URL,
    })
    .buildStore()
